// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-3425aebe]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.search .input[data-v-3425aebe],\n.search .date[data-v-3425aebe],\n.search .select[data-v-3425aebe] {\n  width: 200px;\n  margin-right: 10px;\n  margin-top: 10px;\n}\n.search .btn-group[data-v-3425aebe] {\n  display: inline-block;\n  margin-top: 10px;\n}", ""]);
// Exports
module.exports = exports;
